<template>
<div class="1Wontainer" style="padding-top: 0rem;">

	<div class="row">
		<div class="col-lg-12">
		
			<div class="support-index content-box ">
				<!-- add panel-fullscreen for fullscreen -->
				<div class="support-ticket-content-w folded-info">

					<div class="support-ticket-content ">

						<div class="ticket-thread">



							<div class="element-box " style="-webkit-box-shadow: none; box-shadow: none;">
								<h1>Outcome of scenarios</h1>
<!-- balance -->
<ve-line :colors="chartRcolors" :data="chartDataR" :settings="chartSettingsR"></ve-line>
							<div class="row">
								<hr style="border: none;">
								<div class="col-lg-12">
									<h5>Initial balance  <a @click.prevent="editBalance" class="pop" style="padding-left: 8px;padding-right: 8px; cursor: pointer;"><i class="icon-feather-edit" style="color:#6f42c1;"></i> <span style="color: black;"> ${{startingBalance}}</span> </a></h5>
		
									<div id="balanceTable" class="table"></div>
								
								</div>
							</div>
							</div>
							<!-- chart start -->
							<!-- chart end -->
							<!-- balance -->

							




						</div>
					</div>
				</div>
			</div>


		</div>

	</div>
</div>


</template>
<style>
.element-box, .invoice-w, .big-error-w {
    -webkit-animation-name: none;
    animation-name: none;
    /* -webkit-animation-duration: 1s; */
    /* animation-duration: 1s; */
}
</style>

<script>
// 

var menuDelete = function () { 
	window.dispatchEvent(new CustomEvent("hello", {detail: { name: "John" }}));
}

 var groupBy = require('lodash.groupby')
import axios from 'axios'
import * as moment from 'moment';
import store from './../store'
// require styles
import Tabulator from 'tabulator-tables'
import VeHistogram from 'v-charts/lib/histogram.common'
import VeLine from 'v-charts/lib/line.common'
import has from 'lodash.has'
 import notie from 'notie'
 import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/light.css'; // light-border.css  light.css  material.css  translucent.css

require('tabulator-tables/dist/css/tabulator_simple.min.css')
window.tippy = tippy
var printIcon = function(cell, formatterParams, onRendered){ //plain text value
		// console.log('printIcon', cell._cell.row.data.name,cell)
    return '<i class="tt icon-feather-more-horizontal" data-parent="' + cell._cell.row.data.name + '" style="color:#2347cc;"></i>';
};
var printIconHidden = function(cell, formatterParams, onRendered){ //plain text value
// return `<b-button v-b-popover.hover="'I am popover content!'" title="Popover Title">Hover Me</b-button>`
    return '<i class="icon-feather-minus-circle" style="color:white;"></i>';
};

export default {
	name: 'Forecast',
	components: {
		VeHistogram,
		VeLine
  },
  filters: {

	},
	
  data () {
		
		this.chartSettingsR = {
        labelMap: {
          balance: 'Scenario: All good',
          age: 'Scenario: New car'
        }
      }
    return {
			startingBalance: 0,
			chartDataR:  {
          columns: ['date', 'balance', 'age'],
          rows: [
            { 'date': 'Jan', 'balance': 123, 'age': 3 },
            { 'date': 'Feb', 'balance': 1223, 'age': 6 },
            { 'date': 'Mar', 'balance': 2123, 'age': 9 }
          
          ]
        },
			isMounted: false,
			balanceData: [],
			incomeData: [],
			expenseData: [],
			// https://dribbble.com/shots/3879864-Dashboard-Loading-Animation
			chartRcolors: 
				[
					'#6b45d0',
				'#44a8d6',
				'#bc5090',
				
				'#ffa600',
				'#003f5c'
				]
		}
			
  },
  methods: {
		editBalance () {
			console.log('editBalance')
			let that = this
			notie.input({
				value: that.startingBalance,
        text: '<i class="icon-feather-message-circle"></i>  What is your initial balance ?  <span style="color: #999;">(press enter to submit)</span>',
        cancelCallback: function (value) {
          // notie.alert({ type: 3, text: 'Cancelled'})
        },
        submitCallback: function (value) {
					// value = value.replace(/\s+/g, '')
					//let capt = value.charAt(0).toUpperCase() + value.slice(1)
					that.startingBalance = value
					// that.addRowAfterDialog(table,capt)
        },
        type: 'text',
        //placeholder: 'something',
        // allowed: new RegExp('(^delete$)', '')
      })
		},
		loadTest () {
			let scenarios = [
				{
					id: 'sfsdf',
					name: 'Title',
					description: 'fadf',
					expenseData: [],
					incomeData: [],
					balanceData: []
				}
			]
		},
    act () {
      console.log('act')
		},
		refresh () {
			console.log('refresh')
			this.balanceData = []
			this.balanceData = [
					{name:"Balance", Jan: 100000, Feb: 200000,Mar: 200000,Apr: 200000,May: 200000,Jun: 200000, Jul: 200000,Aug: 200000,Sep: 200000,Oct: 200000,Nov: 200000,Dec: 200000 },
					{name:"PL", Jan: 100000, Feb: 200000,Mar: 200000,Apr: 200000,May: 200000,Jun: 200000, Jul: 200000,Aug: 200000,Sep: 200000,Oct: 200000,Nov: 200000,Dec: 200000 }
			]
			window.balanceTable.replaceData(this.balanceData)
		}
  },
  mounted () {
	 		let that = this
	 		window.balanceTable = new Tabulator("#balanceTable", {
			columns:[
			{rowHandle:true, formatter:"handle", headerSort:false, frozen:true, width:30, minWidth:30},
			{headerSort:false,title:" ", field:"name", editor:"input",width:200, responsive:0}, //never hide this column
			{title:"Jan", field:"Jan", headerSort:false},
			{title:"Feb", field:"Feb", headerSort:false},
			{title:"Mar", field:"Mar", headerSort:false},
			{title:"Apr", field:"Apr", headerSort:false},
			{title:"May", field:"May", headerSort:false},
			{title:"Jun", field:"Jun", headerSort:false},
			{title:"Jul", field:"Jul", headerSort:false},
			{title:"Aug", field:"Aug", headerSort:false},
			{title:"Sep", field:"Sep", headerSort:false},
			{title:"Oct", field:"Oct", headerSort:false},
			{title:"Nov", field:"Nov", headerSort:false},
			{title:"Dec", field:"Dec", headerSort:false},
			{headerSort:false,formatter:printIconHidden, width:40, align:"center"},
			],
			dataTree:false,
			layout:"fitColumns",
			dataTreeStartExpanded:false,
			movableRows: false,
			selectable:false,
			responsiveLayout:"collapse"
			// keybindings:{
			//		"navRight" : '39',
			//		"navLeft": '37'
			// }
		})
		this.balanceData = [
		{name:"Balance", Jan: 100000, Feb: 200000,Mar: 200000,Apr: 200000,May: 200000,Jun: 200000, Jul: 200000,Aug: 200000,Sep: 200000,Oct: 200000,Nov: 200000,Dec: 200000 },
	]
		window.balanceTable.replaceData(this.balanceData)
	this.refresh()

 }
}
</script>
<style>
.ql-container {
    font-size: 1rem;
}
.ql-editor{
    min-height:200px;
}
.panel-fullscreen {
    display: block;
    z-index: 9999;
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    overflow: auto;
}

.btncon {
    display: inline-block;
    position: relative;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    border: none;
    outline: none;
    background-color: transparent;
    fill: currentColor;
    color: inherit;
  /*  font-size: 24px; */
    text-decoration: none;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
 /*   width: 48px;
    height: 48px;
    padding: 12px; */
}
.btncon:hover {
	color:#2347cc;	
}


 .tabulator-selectable {
/*
border-left-width: 2px !important;
 border-color: white;
 color: #656565;
   border-left-style: solid;
	    border-top: none;
		border-bottom: none;
		*/
    cursor: pointer;

}

 .tabulator-row.tabulator-selectable:hover {
    /* background-color: red !important; */
		background-color: #fffae6 !important;

		border-radius: 12px;
		color: black;
    cursor: pointer;
}

 .tabulator-row .tabulator-selectable:hover {
    background-color: #a94442;
    cursor: pointer;
}


 .tabulator-row.tabulator-selectable:hover {
    background-color: #bbb;
    cursor: pointer;
 }

/*
 .tabulator-selectable:hover {
  border-color: #22BAA0;
	color: black;
	border: 1px solid #22BAA0;
	border-left: none;
	border-right: none;
    border-left-width: 2px !important;
    border-left-style: solid;
    border-top: none;
		border-bottom: none;
    cursor: pointer;
}
*/
.tabulator-header {
font-family: "proxima_nova_ltsemibold","HelveticaNeue", "Helvetica Neue", Helvetica, Arial,sans-serif;
    /* border-bottom: none; */
		border: none;
		/* border-bottom: 2px solid #dee2e6; */
		color: #656565;
    line-height: 1.5;
		font-size: 10px;
    text-transform: uppercase;
}

.tabulator-footer {
	text-align: center !important;
}

/* colors in modal */
.cblack {
	color: black;
}


.cgray {
	color: #333;
	/* #c9c9c9 */
}

a.pop:hover{
color: #6f42c1 !important;
    background-color: #e9ecef !important;
    text-decoration: none !important;
}
</style>
